import script from "./ChapterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterPage.vue?vue&type=script&setup=true&lang=js"

import "./ChapterPage.vue?vue&type=style&index=0&id=3d6ea1bc&lang=css"

const __exports__ = script;

export default __exports__